import { render, staticRenderFns } from "./ReplacementPage.vue?vue&type=template&id=2d5110ed&"
import script from "./ReplacementPage.vue?vue&type=script&lang=ts&"
export * from "./ReplacementPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports